// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class UpsearchModelPharmacyPharmacyUpsearchModel {
    static getAttributeTypeMap() {
        return UpsearchModelPharmacyPharmacyUpsearchModel.attributeTypeMap;
    }
}
UpsearchModelPharmacyPharmacyUpsearchModel.discriminator = undefined;
UpsearchModelPharmacyPharmacyUpsearchModel.additionalProperties = false;
UpsearchModelPharmacyPharmacyUpsearchModel.attributeTypeMap = [
    {
        "name": "canUpdate",
        "baseName": "canUpdate",
        "type": "boolean"
    },
    {
        "name": "canInsert",
        "baseName": "canInsert",
        "type": "boolean"
    },
    {
        "name": "skipSearch",
        "baseName": "skipSearch",
        "type": "boolean"
    },
    {
        "name": "model",
        "baseName": "model",
        "type": "PharmacyUpsearchModel"
    },
];
//# sourceMappingURL=upsearchModelPharmacyPharmacyUpsearchModel.js.map